var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStatusReview(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#00B2A9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.14 18.1399C10.3219 18.1399 11.28 17.1818 11.28 15.9999C11.28 14.818 10.3219 13.8599 9.14 13.8599C7.95811 13.8599 7 14.818 7 15.9999C7 17.1818 7.95811 18.1399 9.14 18.1399Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 18.1399C17.1819 18.1399 18.14 17.1818 18.14 15.9999C18.14 14.818 17.1819 13.8599 16 13.8599C14.8181 13.8599 13.86 14.818 13.86 15.9999C13.86 17.1818 14.8181 18.1399 16 18.1399Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.14 18.28C24.3219 18.28 25.28 17.3219 25.28 16.14C25.28 14.9581 24.3219 14 23.14 14C21.9581 14 21 14.9581 21 16.14C21 17.3219 21.9581 18.28 23.14 18.28Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusReview);
export default __webpack_public_path__ + "static/media/status-review.85713a3d54b4ea315f374c5c378f332b.svg";
export { ForwardRef as ReactComponent };